import { Box, styled } from '@mui/material';
import _ from 'lodash';
import { withShowable } from '../../../_global/lib/withShowable';
import { useStatusColors } from '../../../quotes-policies/cards/policyholder/utils';
import {
  LeftBadge,
  ArrowLeft,
} from '../../../quotes-policies/drawers/LeftBadge';

export const PolicyHolderQuoteDrawerHeader = ({ quote }: any) => {
  const statusColor = useStatusColors(quote.customerStatus);

  return (
    <FlexBox width="100%" justifyContent="space-between" alignItems="center">
      <MidtermBadge show={!!quote.isEndorsement}>
        Midterm
        <ArrowLeft />
      </MidtermBadge>
      <RenewalBadge show={!!quote.isRenewal}>
        Renewal
        <ArrowLeft />
      </RenewalBadge>
      <Box height="2rem" width="1rem" />
      <HeaderText show={!_.isUndefined(quote.quoteNumber)}>
        {`Quote Number: ${quote.quoteNumber || '-'}`}
        <DrawerHeaderSpan
          style={{ color: statusColor }}
        >{`[${quote.customerStatus}]`}</DrawerHeaderSpan>
      </HeaderText>
      <IsSurplusBadge>{quote.isSurplus ? 'S' : 'A'}</IsSurplusBadge>
    </FlexBox>
  );
};

const FlexBox = styled(Box)(() => ({
  display: 'flex',
  position: 'relative',
}));

const DrawerHeaderText = styled('h1')(({ theme: { palette, config } }) => ({
  color: palette.primary.main,
  fontWeight: config.weights.normal,
  margin: 0,
  fontSize: config.textSizes.paragon,
  paddingLeft: '0.5rem',
}));

const HeaderText = withShowable(DrawerHeaderText);

const DrawerHeaderSpan = styled('span')(({ theme: { palette, config } }) => ({
  color: 'green',
  fontSize: config.textSizes.greatPrimer,
  marginLeft: '0.75rem',
  textTransform: 'uppercase',
}));

const IsSurplusBadge = styled(FlexBox)(({ theme: { palette, config } }) => ({
  color: palette.primary.main,
  fontWeight: config.weights.normal,
  margin: 0,
  fontSize: config.textSizes.primer,
  border: `1px solid ${palette.text.text12}`,
  borderRadius: '1rem',
  width: '2rem',
  height: '2rem',
  justifyContent: 'center',
  alignItems: 'center',
}));

const MidtermBadge = withShowable(
  styled(LeftBadge)(({ theme: { palette } }) => ({
    backgroundColor: palette.snackBar.primary,
  }))
);

const RenewalBadge = withShowable(
  styled(LeftBadge)(({ theme: { palette } }) => ({
    backgroundColor: palette.common.cowbellBlue,
  }))
);
